import { render, staticRenderFns } from "./CustomTableView.vue?vue&type=template&id=39d3f98f&scoped=true"
import script from "./CustomTableView.vue?vue&type=script&lang=js"
export * from "./CustomTableView.vue?vue&type=script&lang=js"
import style0 from "./CustomTableView.vue?vue&type=style&index=0&id=39d3f98f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d3f98f",
  null
  
)

export default component.exports